"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleUserId = void 0;
function handleUserId(user) {
    return user.id || user._id || '';
}
exports.handleUserId = handleUserId;
